// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"13bf0833d92468739e70","293":"858a1e2d4628da9eced8","518":"7f44ff8149d14147ee9a","779":"a2af831a3f6eba168022"}[chunkId] + ".js";
};